/* eslint react/jsx-props-no-spreading: ["off"] */

import React from 'react'
import PropTypes from 'prop-types'
import { Route, Redirect } from 'react-router-dom'
import { isLoggedIn } from 'utils/logged'
import { LOGIN } from 'constants/app-paths'

function PrivateRoute({ children, ...rest }) {
  return (
    <Route
      {...rest}
      render={({ location }) => (
        isLoggedIn()
          ? children
          : <Redirect to={{ pathname: LOGIN, state: { from: location } }} />
      )}
    />
  )
}

PrivateRoute.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
  ]).isRequired,
}

export default PrivateRoute
